module.exports = __webpack_public_path__ + "static/media/creature-desk.8cb434c1.svg";